import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Image,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    ModalCloseButton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import colors from '../../theme/foundations/colors'

export const WeChatModal = ({isOpen, onClose}) => {
    const intl = useIntl()

    return (
        <Modal id="wechat-modal" isOpen={isOpen} onClose={onClose} aria-modal={true}>
            <ModalOverlay />
            <ModalContent
                aria-label={intl.formatMessage({
                    id: 'wechatmodal.aria-label',
                    defaultMessage: 'Modal with WeChat QR code'
                })}
                w={'auto'}
            >
                <ModalCloseButton />
                <ModalBody mt={34} p={0}>
                    <Text variant={'bodyBase2'} color={colors.darkGray}>
                        {intl.formatMessage({
                            id: 'wechatmodal.text',
                            defaultMessage: 'Scan the QR code below to follow'
                        })}
                    </Text>
                    <Image
                        width={247}
                        height={247}
                        src={getAssetUrl('static/img/wechat_qr.png')}
                        alt={intl.formatMessage({
                            id: 'wechatmodal.imgalt',
                            defaultMessage: 'WeChat Vilebrequin QR Code'
                        })}
                    ></Image>
                    <Text variant={'bodyBase2'} color={colors.darkGray}>
                        {intl.formatMessage({
                            id: 'wechatmodal.brand',
                            defaultMessage: 'Vilebrequin Official'
                        })}
                    </Text>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

WeChatModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
}
